import { useContextStrict } from 'hooks/useContextStrict';
import { AppStateContext } from 'contexts/AppStateContext';

export const useAppState = () => {
  return useContextStrict(AppStateContext);
};
